/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { KTSVG, toAbsoluteUrl } from '../../../helpers'
import { Dropdown1 } from '../../content/dropdown/Dropdown1'
import { ReviewActionsCell } from '../../../../app/modules/apps/artificial-intelligence/review-list/table/columns/ReviewActionsCell'
import { combineSelect2Values } from '../../../helpers/utility'
import { LanguageHelp } from '../../../helpers/LanguageHelper'

type Props = {
  className: string,
  row?: any
  reviewChannels?: any[]
}

const FeedsWidget1: React.FC<Props> = ({ className, row, reviewChannels }) => {
  let url = ""
  reviewChannels?.forEach((reviewChannel) => {
    if (reviewChannel.key === row.original.sourceId) {

      switch (reviewChannel.type) {
        case 2: url = "/media/svg/brand-logos/twitter.svg"; break;
        case 3: url = "/media/svg/brand-logos/sikayetvar.png"; break;
        case 4: url = "/media/svg/brand-logos/facebook-3.svg"; break;
        case 5: url = "/media/svg/brand-logos/eksisozluk.svg"; break;
        case 7: url = "/media/svg/brand-logos/instagram-2-1.svg"; break;
        case 8: url = "/media/svg/brand-logos/youtube.svg"; break;
        case 9: url = "/media/svg/brand-logos/reddit.svg"; break;
        case 10: url = "/media/svg/brand-logos/instagram-comments.png"; break;
        case 11: url = "/media/svg/brand-logos/tiktok-sharing.png"; break;
        case 12: url = "/media/svg/brand-logos/tiktok-comments.png"; break;
        default: url = "/media/svg/general/api-cloud.svg"; break;
      }
    }
  })

  return (
    <div className={`card ${className}`}>
      <div className='card-body pb-0'>
        <div className='d-flex align-items-center mb-5'>
          <div className='d-flex align-items-center flex-grow-1'>
            <div className='symbol symbol-45px me-5'>
              {url !== '' && <img src={toAbsoluteUrl(url)} alt='' />}
            </div>
            <div className='d-flex flex-column'>
              <div className='text-gray-800 fs-6 fw-bold'>
                {row.original.source}
              </div>
              <span className='text-gray-400 fw-semibold'>{row.original.createDate}</span>
            </div>
          </div>
          {row.original.reviewUrl !== null && row.original.reviewUrl !== '' &&
            <a href={row.original.reviewUrl} target='_blank' className='text-gray-800 text-hover-primary me-5' >
              &nbsp;<KTSVG path='/media/icons/duotune/arrows/arr095.svg' className='svg-icon-2' />
            </a>
          }
          <ReviewActionsCell isReviewLoading={false} id={row.original.id} status={row.original.status} />
        </div>
        <div className='mb-5'>
          <p className='text-gray-800 fw-normal mb-5'>
            {row.original.text}
          </p>

          <div className='d-flex align-items-center mb-5'>
            <div className={`btn btn-sm btn-light ${row.original.reviewViewCount === 0 ? 'btn-color-muted' : 'btn-light-success'} px-4 py-2 me-4`}>
              <i className="fa-solid fa-eye"></i>{row.original.reviewViewCount}
            </div>
            <div className={`btn btn-sm btn-light ${row.original.reviewCommentCount === 0 ? 'btn-color-muted' : 'btn-light-success'} px-4 py-2 me-4`}>
              <i className="fa-solid fa-message"></i>{row.original.reviewCommentCount}
            </div>
            <div className={`btn btn-sm btn-light ${row.original.reviewLikeCount === 0 ? 'btn-color-muted' : 'btn-light-success'} px-4 py-2 me-4`}>
              <i className="fa-solid fa-heart"></i>{row.original.reviewLikeCount}
            </div>
            {/* <div className={`btn btn-sm btn-light ${row.original.reviewDislikeCount === 0 ? 'btn-color-muted' : 'btn-light-danger'} px-4 py-2 me-4`}>
              <i className="fa-solid fa-heart-crack"></i>{row.original.reviewDislikeCount}
            </div> */}
            <div className={`btn btn-sm btn-light ${row.original.reviewShareCount === 0 ? 'btn-color-muted' : 'btn-light-success'} px-4 py-2 me-4`}>
              <i className="fa-solid fa-retweet"></i>{row.original.reviewShareCount}
            </div>
          </div>
        </div>

        <div className='separator mb-4'></div>

        <div className='d-flex'>
          <p className='text-dark fw-bold me-1'>{LanguageHelp('Sentiment')}: </p>
          <p className='text-gray-800 fw-normal'>{LanguageHelp(row.original.sentiment + '')}</p>
        </div>
        <div className='d-flex mb-5'>
          <p className='text-dark fw-bold me-1'>{LanguageHelp('Subjects')}: </p>
          <div>{combineSelect2Values(row.original.subjectList)}</div>
        </div>

        {/* <form className='position-relative mb-6'>
          <textarea
            className='form-control border-0 p-0 pe-10 resize-none min-h-25px'
            rows={1}
            placeholder='Reply..'
          ></textarea>

          <div className='position-absolute top-0 end-0 me-n5'>
            <span className='btn btn-icon btn-sm btn-active-color-primary pe-0 me-2'>
              <i className="fas fa-paper-plane"></i>
            </span>
          </div>
        </form> */}
      </div>
    </div>
  )
}

export { FeedsWidget1 }
